export const timeTypes = {
  FOUR_HOURS: {
    name: 'FOUR_HOURS',
    time: '4 hours',
  },
  EIGHT_HOURS: {
    name: 'EIGHT_HOURS',
    time: '8 hours',
  },
  SIXTEEN_HOURS: {
    name: 'SIXTEEN_HOURS',
    time: '16 hours',
  },
  TWENTY_FOUR_HOURS: {
    name: 'TWENTY_FOUR_HOURS',
    time: '24 hours',
  },
  FORTY_EIGHT_HOURS: {
    name: 'FORTY_EIGHT_HOURS',
    time: '48 hours',
  },
  SEVENTY_TWO_HOURS: {
    name: 'SEVENTY_TWO_HOURS',
    time: '72 hours',
  },
};
